import Vue from "vue";

import SnowInput from "./form/SnowInput.vue";
import SnowSelect from "./form/SnowSelect.vue";
import SnowButton from "./SnowButton.vue";
import SnowCheckbox from "./SnowCheckbox.vue";
import SnowCheckboxesDropdown from "./SnowCheckboxesDropdown.vue";
import SnowCheckboxGroup from "./SnowCheckboxGroup.vue";
import SnowInputFile from "./SnowInputFile.vue";
import SnowRadio from "./SnowRadio.vue";

Vue.component("snow-button", SnowButton);
Vue.component("snow-input-file", SnowInputFile);
Vue.component("snow-select", SnowSelect);
Vue.component("snow-checkbox", SnowCheckbox);
Vue.component("snow-checkbox-group", SnowCheckboxGroup);
Vue.component("snow-checkboxes-dropdown", SnowCheckboxesDropdown);
Vue.component("snow-radio", SnowRadio);
Vue.component("snow-input", SnowInput);
